import { observer } from 'mobx-react-lite';
import React from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { GroupAvatar } from 'APP/components/Avatar/GroupAvatar/GroupAvatar';
import { SecureChatBadge } from 'APP/components/SecureChatBadge/SecureChatBadge';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { GroupStatus } from 'APP/main/components/GroupStatus/GroupStatus';
import { GroupType } from 'APP/model/group/groupModel.types';
import { Group } from 'STORE/Groups/Group';

import OfflineStatus from '../components/OfflineStatus';
import styles from './GroupChatInfo.styles.m.css';

interface IGroupChatInfoProps {
  group: Group;
  hideMembersCount?: boolean;
}
export const GroupChatInfo: React.FC<IGroupChatInfoProps> = observer(
  ({ group, hideMembersCount }) => {
    const { t } = useTranslation();

    return (
      <>
        <GroupAvatar
          isShowAutoCleanupIndicator
          group={group}
        />
        <div className={styles.content}>
          <div className={styles.titleWrapper}>
            {group.type === GroupType.SecretGroup ? (
              <SecureChatBadge className={styles.secureIcon} />
            ) : null}
            <span className={styles.title}>{group.avatarTitle}</span>
            {group.verified && <VerifiedBadge />}
          </div>
          <OfflineStatus>
            <GroupStatus group={group}>
              {!hideMembersCount && (
                <span className={styles.membersCount}>
                  {t('amount_of_members_in_a_group_many', { 0: group.usersCount })}
                </span>
              )}
            </GroupStatus>
          </OfflineStatus>
        </div>
      </>
    );
  }
);
